<template>
    <div id="reviews">
        <div v-if="loading">
            <device-filter-reviews-skeleton />
        </div>
        <template v-else>
            <div class="pb-2">
                <p class="fw-bold pb-0">
                    {{ reviewsMessages.sortTitle }}
                </p>
                <ob1-radio-button-list
                    :radios-buttons="radioButtons"
                    @change="reviewDateSortHandler"
                />
            </div>

            <template v-if="ratingsFilterCheckBoxes.length > 0">
                <hr class="mb-2 separator separator--gray4">
                <p class="fw-bold pb-0">
                    {{ reviewsMessages.ratingsFilterTitle }}
                </p>
                <ul class="items-list">
                    <template v-for="rating in ratingsFilterCheckBoxes">
                        <li :key="rating.id">
                            <div class="items-list-item">
                                <div class="item-container item-container-sm">
                                    <ob1-check-box2
                                        :id="device + '-' + rating.id"
                                        v-model="rating.isChecked"
                                        :name="device + '-rating-' + rating.id"
                                        :label="getCountLabel(rating.label, rating.count)"
                                        :is-indeterminated="rating.isIndeterminated"
                                        :aria-labelled-by="getCountLabel(rating.label, rating.count)"
                                        @change="ratingFilterHandler(rating.label, rating.isChecked)"
                                    />
                                    <span
                                        class="item-text"
                                        v-html="getCountLabel(rating.label, rating.count)"
                                    />
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
            </template>
        </template>
    </div>
</template>

<script>
import DeviceFilterReviewsSkeleton from "./DeviceFilterReviewsSkeleton.vue";

export default {
    name: "DeviceFilterReviews",
    components: {DeviceFilterReviewsSkeleton},
    props: {
        ratingsFilterCheckBoxes: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        reviewsMessages: {
            type: Object,
            required: true
        },
        // Type de device
        device: {
            type: String,
            required: true
        },
        dateSortRadioButtons: {
            type: Array,
            required: true
        },
    },
    computed: {
        radioButtons() {
            return this.dateSortRadioButtons.map(sort => ({
                radioButtonDTO: {
                    id: this.device + '-' + sort.radioButtonDTO.id,
                    name: this.device + '-' + sort.radioButtonDTO.name,
                    label: sort.radioButtonDTO.label,
                    checked: sort.radioButtonDTO.checked,
                    ariaLabelledBy: sort.radioButtonDTO.ariaLabelledBy,
                    value: sort.radioButtonDTO.value
                },
                primaryText: sort.primaryText
            }));
        }
    },
    methods: {
        ratingFilterHandler(label, isChecked) {
            const state = isChecked ? "_coche" : "_decoche";
            Tms.link({
                category: "detail_produit",
                action: stripAccents(label).split(' ').join('_'),
                label: "choix_filtre_note_" + stripAccents(label).split(' ').join('_') + state
            })

            this.$emit('change-check-box-ratings-filter', this.ratingsFilterCheckBoxes.filter(checkbox => checkbox.isChecked).map(id => id.id))
        },
        reviewDateSortHandler(sortId) {
            let selectedSort = this.radioButtons.find(sort => sort.radioButtonDTO.id === sortId)
            if (selectedSort) {
                this.$emit('review-date-sort-item-click', selectedSort.radioButtonDTO.value);
            }
        },
        getCountLabel(label, count) {
            return label + ' (' + count + ')';
        },
    }
}
</script>
